type TripFieldProps = {
  label: string;
  value: string;
};

export function TripField({ label, value }: TripFieldProps) {
  return (
    <>
      <div className="flex-1">
        <p className="text-xs font-medium text-muted">{label}</p>
        <p className="text-sm font-medium text-foreground">{value}</p>
      </div>
    </>
  );
}
